const sizes = {
  container: {
    sm: '327px',
    lg: '540px',
  },
};

export default sizes;
